export { HomeComponent } from './components/home/home.component';
export { NavbarComponent } from './components/navbar/navbar.component';
export { FooterComponent } from './components/footer/footer.component';
export { PerfilComponent } from './components/perfil/perfil.component';

//new
export { AdministrarblogComponent } from './components/administrarblog/administrarblog.component';
export { UploadFileComponent } from './components/upload-file/upload-file.component';
export { AdministraCategoriasComponent } from './components/administra-categorias/administra-categorias.component';
export { AdministraProductosComponent } from './components/administra-productos/administra-productos.component';
export { AdministraMarcasComponent } from './components/administra-marcas/administra-marcas.component';
export { ReporteVentasComponent } from './components/reporte-ventas/reporte-ventas.component';
export { AdministraImgProductoComponent } from './components/administra-img-producto/administra-img-producto.component';
export { AdministraImgMcComponent } from './components/administra-img-mc/administra-img-mc.component';



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/index.paginas.ts